import styled from "styled-components";
import { theme } from "@themes";

export const CardContainer = styled.div`
  margin: 4px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
    transition: 0.5s;
    transform: translate(-3px, -3px);
  }
`;

export const TitleContainer = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }) => theme.text.primary};
  letter-spacing: 0.01em;
  margin-bottom: 5%;
`;

export const LogoCard = styled.span`
  margin: 5%;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: center;
`;
